export const mapTemplatePropsToStyles = (template: Record<string, any>) => ({
  ...(template.strokeColor &&
    template.strokeWidth && {
      '-webkit-text-stroke-width': `${(
        +(template.strokeWidth.split(' vmin')[0] || 0) * 0.6
      ).toString()}px`,
      '-webkit-text-stroke-color': template.strokeColor,
      'letter-spacing': '0.3px',
      'font-size': `${(
        12 +
        (+template.strokeWidth.split(' vmin')[0] || 0) * 0.6
      ).toString()}px`,
    }),
  ...(template.backgroundColor &&
    template.backgroundColor !== 'transparent' && {
      padding: '1px 6px',
      background: template.backgroundColor,
      opacity: template.backgroundTransparency,
      'border-radius': `${(
        (Number(template.backgroundBorderRadius?.split('%')[0]) || 0) * 0.1
      ).toString()}px`,
    }),
  ...(template.shadowColor &&
    template.shadowBlur != null &&
    template.shadowXOffset != null &&
    template.shadowYOffset != null && {
      [template.backgroundColor && template.backgroundColor !== 'transparent'
        ? 'box-shadow'
        : 'text-shadow']: `${template.shadowXOffset * 0.6}px ${
        template.shadowYOffset * 0.6
      }px ${template.shadowBlur * 0.6}px ${template.shadowColor}`,
    }),
  color: template.fillColor,
});
